module.exports = __webpack_public_path__ + "static/img/on.b1a8eb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/on.png
// module id = 59
// module chunks = 1